<template>
    <div class="l-login">
        <div class="l-form">
            <div class="justify-content-center" style="margin-left: 15%;">
                <img src="https://chezagame.com/images/chezagame-logo.png" width="190px" />
            </div>
            <div class="row">
                <form @submit.prevent="goToVerify" v-if="!verifyStatus">
                    <div class="col">
                        <h2>Verify | ChezaGame</h2>
                        <div v-show="verifyStatus">
                            <small class="text-red">{{verifyMessage}}</small>
                        </div>
                    </div>
                    <div class="col">
                        <label>Verification Code</label>
                        <input type="password" v-model="verifyCode" placeholder="xxxx" />
                    </div>
                    <div class="col">
                        <label>Password</label>
                        <input type="password" v-model="newPassword" placeholder="xxxx" />
                    </div>
                    <div class="col">
                        <label>Confirm Password</label>
                        <input type="password" v-model="confirmPassword" placeholder="xxxx" />
                    </div>
                    <div class="col">
                        <button class="button primary" id="verify" @click="goToVerify()">Next</button>
                    </div>
                </form>
            </div>
        </div>
    
    </div>
</template>

<script>
import store from "../store";
import $ from 'jquery'
export default {
    data: function() {
        return {
            msisdn: '',
            verifyStatus: false,
            verifyMessage: '',
            verifyCode: "",
            newPassword: "",
            confirmPassword: ""
        }
    },
    mounted() {
        let vm = this
        if (!vm.$cookies.get("user_name")) {
            vm.$router.push({
                name: 'login'
            })
        }
    },
    methods: {
        goToVerify() {
            this.verifyStatus = false;
            this.verifyMessage = "";
            var vm = this;
            $('#verify').html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            if (vm.newPassword != vm.confirmPassword) {
                $('#verify').html('Next');
                vm.verifyStatus = false;
                vm.verifyMessage = "New Password and Old Password should be the same";

            } else {
                $.post({
                    url: store.state.rootUrl + 'portal/v1/verify',
                    type: "POST",
                    headers: {
                        "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                        "X-Authorization-Key": "ADMIN_APP",
                        "X-Requested-With": "XMLHttpRequest",
                        "Content-Type": "application/json"
                    },
                    data: JSON.stringify({
                        user_name: vm.$cookies.get("user_name"),
                        country_code: "254",
                        new_password: vm.newPassword,
                        verification_code: vm.verifyCode
                    }),
                    success: function(response, status, jQxhr) {
                        if (response.data.code != 200) {
                            vm.verifyStatus = true;
                            vm.verifyMessage = response.data.message
                        } else {
                            $('#verify').html('Next');
                            vm.$cookies.remove("user_name");
                            vm.$router.push({
                                name: 'login'
                            });
                        }

                    },
                    error: function(jQxhr, status, error) {
                        var statustext = jQxhr.responseJSON.statusDescription;
                        vm.verifyStatus = true;
                        $('#verify').html('Next');
                        if (!statustext) {
                            vm.verifyMessage = "An error occurred. Try again later.";
                        } else {
                            vm.verifyMessage = statustext + " " + jQxhr.responseJSON.data.message;
                        }
                    }
                });
            }

        }
    }
}
</script>
